export default __webpack_public_path__ + "static/media/button-about.min.6153ff08.svg";